import { mountStoreDevtool } from 'simple-zustand-devtools'
import { UserPrivileges } from 'types/usuario'
import { create } from 'zustand'
import { combine, persist, createJSONStorage } from 'zustand/middleware'

interface UserInfo {
  id: string
  id_usuario: number
  cd_usuario: string
  nm_usuario: string
  expira: string
  id_unidade_negocio: number
  id_empresa: number
  id_comissionado: number
  id_ponto_venda: number
  cd_comissionado: string
  cd_ponto_venda: string
  id_forma_acesso: string
  nivel_particularidade: number
  globalcachekey: string
  id_identificador: number
  sn_acesso_simultaneo: string
  cd_empresa: string
  nm_empresa: string
  versao_sistema: number
  release_sistema: number
  cd_inscricao_nacional_comissionado: string
  privilegios: UserPrivileges
}

const DEFAULT_USER_INFO: UserInfo = {
  nm_usuario: '',
  id: '',
  id_usuario: 0,
  cd_usuario: '',
  expira: '',
  id_unidade_negocio: 0,
  id_empresa: 0,
  id_comissionado: 0,
  id_ponto_venda: 0,
  cd_comissionado: '',
  cd_ponto_venda: '',
  id_forma_acesso: '',
  nivel_particularidade: 0,
  globalcachekey: '',
  id_identificador: 0,
  sn_acesso_simultaneo: '',
  cd_empresa: '',
  nm_empresa: '',
  versao_sistema: 0,
  release_sistema: 0,
  cd_inscricao_nacional_comissionado: '',
  privilegios: {} as UserPrivileges
}

const useUserInfoStore = create(
  persist(
    combine(DEFAULT_USER_INFO, (set) => ({
      setUserInfo: (userInfo: UserInfo) => set(userInfo),
      setUserPrivileges: (privileges: UserPrivileges) => set(() => ({ privilegios: privileges })),
      resetState: () => set(() => ({ ...DEFAULT_USER_INFO }))
    })),
    {
      name: 'user-info',
      storage: createJSONStorage(() => localStorage)
    }
  )
)

if (process.env.NODE_ENV === 'development') {
  mountStoreDevtool('User Store', useUserInfoStore)
}

export default useUserInfoStore
